export default "__VITE_ASSET__RtpCj520__"